import { LameFlooringLayout, ProductType } from 'Plugins/FloorPlan/Components/Laizes/Laize';
import React from 'react';
import { FlooringLayoutProps, FlooringLayoutAssets } from 'Web/assets/flooring_layout/FlooringLayoutAssets';

type FlooringDirectionIconProps = {
    direction: LameFlooringLayout;
    productType: ProductType;
    selected?: boolean;
    props?: FlooringLayoutProps;
};
export const FlooringDirectionIcon = React.memo(
    ({ direction, selected = false, props }: FlooringDirectionIconProps) => {
        if (direction === LameFlooringLayout.LamePleine) {
            return selected ? (
                <FlooringLayoutAssets.LameVerticalSelected />
            ) : (
                <FlooringLayoutAssets.LameVertical props={props} />
            );
        }
        return selected ? (
            <FlooringLayoutAssets.ClassiqueVerticalSelected />
        ) : (
            <FlooringLayoutAssets.ClassiqueVertical props={props} />
        );
    }
);
